import { getOS } from './AppInfo';

export const getIdfaPlugin = () => (getOS() === 'ios' && window?.cordova?.plugins?.idfa) || null;

export { TapToPayPlugin } from './TapToPay/TapToPayPlugin';
